import React, {useState} from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Input,
    Button
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { connect } from 'react-redux';
import { getPayments } from '../redux/actions/payments.action';
import { confirmRedeemCodeValue } from '../redux/actions/rLink.action';
import { toast } from 'react-toastify';
import ModalInvoice from "./components/Modals/ModalInvoice";
import { openPaymentModal, cancelSubscription } from '../redux/actions/payments.action';
var Plans = ["Free", "Free", "Basic", "Chad"];

const Profile = (props) => {
  const { t } = useTranslation(['profile', 'common']);
  function formatTimer(laps) {
    let days = Math.floor(laps / (3600 * 24));
    laps %= (3600 * 24);
    let hours = Math.floor(laps / 3600);
    laps %= 3600;
    let minutes = Math.floor(laps / 60);
    if (days)
        return formatZero(days) + 'd ' + formatZero(hours) + 'h ' + formatZero(minutes) + 'm';
    return formatZero(hours) + 'h ' + formatZero(minutes) + 'm';
  }
  const formatZero = (value) => {
    if (value > 9) return value;
    else return `0${value}`;
  };
  const getPaymentsData = (p) => {
    return p.payments.map((data, key) => {
      var date = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(data.creation);
      return (
        <Card className="cardPayment">
            <CardBody className="paymentLine">
              <Row>
                <Col xs="2">
                  {date}
                </Col>
                <Col xs="2" className="text-center">
                  {`${data.mcGross} ${data.mcCurrency}`}
                </Col>
                <Col xs="3" className="text-center">
                  Completed
                </Col>
                <Col xs="3" className="text-center">
                  {p.active ? <Button className="cancelSubscription" onClick={() => props.cancelSubscription(p.id)}>Cancel subscription</Button> : <>Cancelled subscription</>}
                </Col>
                <Col xs="2" className="text-right">
                  <i className="tim-icons icon-zoom-split" onClick={() => props.openPaymentModal(p, data, JSON.stringify(date))} />
                </Col>
              </Row>
            </CardBody>
          </Card>
      );
    });
  };
  const regexCode = /^\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b$/;
  const [redeemCodeValue, setredeemCodeValue] = useState('');
  const handleSetRedeemCodeValue = (e) => {
      setredeemCodeValue(e.target.value);
  }
  const confirmRedeemCodeValue = () => {
    if (!regexCode.test(redeemCodeValue)) {
      toast.info(t('redeem.badFormating'));
      return;
    }
      props.confirmRedeemCodeValue(redeemCodeValue);
  }
  return (
    <>
      <ModalInvoice />
      <div className="content">
      {/*<div className="referralBody">
          <Row>
            <Col xs="6">
              <div className="referralLink">
                <span className="Title">Referral Link</span>
                <div className="refLink">
                    <span className="text">https://rustlink.io/r/543504354</span>
                    <span className="copyBtn">Copy</span>
                </div>
              </div>
            </Col>
          </Row>
          <div className="referralInformations">
              <Row>
                <Col xs="3">
                  <Card className="referralInformation">
                    <CardHeader>
                      <CardTitle>Total users</CardTitle>
                      <span className="refDescription">Number of referred users</span>
                    </CardHeader>
                    <CardBody>
                      <div className="refValue">12</div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="3">
                  <Card className="referralInformation">
                    <CardHeader>
                      <CardTitle>Your share</CardTitle>
                      <span className="refDescription">Your current commission</span>
                    </CardHeader>
                    <CardBody>
                      <div className="refValue">%5</div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="3">
                  <Card className="referralInformation">
                    <CardHeader>
                      <CardTitle>Total Revenue</CardTitle>
                      <span className="refDescription">Your affiliate earnings</span>
                    </CardHeader>
                    <CardBody>
                      <div className="refValue">12.00 EUR</div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xs="3">
                  <Card className="referralInformation">
                    <CardHeader>
                      <CardTitle>Available Revenue</CardTitle>
                      <span className="refDescription">Total usable revenue</span>
                    </CardHeader>
                    <CardBody>
                      <div className="refValue">2.01 EUR</div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
        </div>
      <div className="spaceLine" />*/}
        <Row>
          <Col lg="6" md="6" sm="6" xs="12">
            <Card className="userCard">
              <CardBody className="userPlan">
                <div className="userPlanLine">
                  <div className="left">{t('currentPlan')}:</div>
                  <div className="right">{Plans[props.vip.plan]}</div>
                </div>
                <div className="userPlanLine">
                  <div className="left">{t('planRemaining')}:</div>
                  <div className="right">{formatTimer(props.vip.remain)}</div>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col lg="6" md="6" sm="6" xs="12">
            <Card className="userCard">
              <CardBody className="redeemCode">
                <Row>
                  <Col xs="2" className="redeemCode_icons">
                    <i className="tim-icons icon-gift-2" />
                  </Col>
                  <Col xs="8">
                    <Input placeholder={t('common:redeem')} value={redeemCodeValue} onChange={handleSetRedeemCodeValue} type="text" />
                  </Col>
                  <Col xs="2" className="redeemCode_icons">
                    <i className="tim-icons icon-check-2" onClick={() => confirmRedeemCodeValue()} />
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/*props.payments && props.payments.length > 0 && */<><div className="spaceLine" /><div className="paymentHistory">
            <div className="title">{t('paymentHistory')}</div>
            <div className="paymentHistoryBody">
            {
                props.payments.map(p => {
                    return(getPaymentsData(p))
                })
            }
            </div>
        </div></>}
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getPayments,
  confirmRedeemCodeValue,
  openPaymentModal,
  cancelSubscription
};

const mapStateToProps = (state) => {
  const { vip } = state.infos;
  const { payments } = state.payments;
  return { vip, payments };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profile);